import React, { Component } from 'react';
import { componentIsInViewport } from '../../utils/dom';
import { sendAnalyticsEvent } from '../../utils/analytics';
import { dataLayerPushSendScrollDepthEvent } from '../../utils/dataLayer';
import getDisplayName from '../../utils/getDisplayName';
import {throttle} from 'lodash';

const defaults = {
  eventParams: () => ['Scroll Depth', 'Scroll'],
  shouldTrackScrollEvent: () => true
};

export default (options = {}) => (WrappedComponent) =>{
  class WithViewportScrollTracking extends Component {
    static displayName =
      `WithViewportScrollTracking(${getDisplayName(WrappedComponent)})`;

    constructor(props, context) {
      super(props, context);
      Object.assign(this, defaults, options);
      this.handleScroll = throttle(this.handleScroll.bind(this), 500);
    }

    componentDidMount() {
      if (this.shouldTrackScrollEvent()) {
        window.addEventListener('scroll', this.handleScroll);
      }
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
      if (componentIsInViewport(this._node, window)) {
        dataLayerPushSendScrollDepthEvent(this.eventParams());
        sendAnalyticsEvent(...this.eventParams());
        window.removeEventListener('scroll', this.handleScroll);
      }
    }

    render() {
      return (
        <div ref={(node) => this._node = node}>
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  }

  if (WrappedComponent.contextTypes) {
    WithViewportScrollTracking.contextTypes = WrappedComponent.contextTypes;
  }

  return WithViewportScrollTracking;
};
